module.exports = __webpack_public_path__ + "img/login_close.9d736cee.svg";